// Export as a module and make available globally
class CoveoUtils {
  constructor() {
    this.pendingRequest = null;
  }

  static async getSearchToken() {
    const storageKey = ["coveoSearchToken", theme.customer.company.id ?? "", window.gic_customer.WarehouseName ?? ""]
      .filter(Boolean)
      .join("-");
    const storedTokenData = localStorage.getItem(storageKey);

    try {
      // Check if we have a valid token in localStorage
      if (storedTokenData) {
        const { token, createdAt, customerId } = JSON.parse(storedTokenData);
        const tokenAge = Date.now() - createdAt;
        const eightHoursInMs = 8 * 60 * 60 * 1000;

        // If token is less than 8 hours old, return it
        if (tokenAge < eightHoursInMs && customerId === theme.customer.id) {
          console.log("Using cached Coveo search token");
          return token;
        }

        console.log("Cached Coveo search token expired, fetching new one");
      }

      if (this.pendingRequest) {
        return this.pendingRequest;
      }

      this.pendingRequest = new Promise(async (resolve, reject) => {
        try {
          // Fetch new token
          const response = (this.pendingRequest = await fetch(
            `${location.origin}/apps/gic-live/api/coveo/search-token`,
            {
              method: "POST",
              credentials: "include", // Include cookies for authentication
              headers: {
                "Content-Type": "application/json",
              },
            },
          ));

          if (!response.ok) {
            return null;
          }

          const data = await response.json();
          const token = data.token;

          // Store token with creation timestamp
          localStorage.setItem(
            storageKey,
            JSON.stringify({
              token,
              createdAt: Date.now(),
              customerId: theme.customer.id ?? null,
            }),
          );

          resolve(token);
        } catch (error) {
          reject(error);
        } finally {
          this.pendingRequest = null;
        }
      });

      return this.pendingRequest;
    } catch (error) {
      console.error("Error fetching Coveo search token:", error);

      // If there's an error but we have a stored token, use it as fallback
      try {
        if (storedTokenData) {
          const { token } = JSON.parse(storedTokenData);
          console.log("Using cached token as fallback after fetch error");
          return token;
        }
      } catch (localStorageError) {
        console.error("Error accessing localStorage:", localStorageError);
      }

      return null;
    }
  }
}

// Make CoveoUtils available globally
window.CoveoUtils = CoveoUtils;

// Also export as a module for ES modules
export default CoveoUtils;
